import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './SrPartnerPortalCard.less';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrButton from 'client/components/SrButton/SrButton';

const SrPartnerPortalCard = ({
  title,
  icon,
  firstDetail,
  secondDetail,
  thirdDetail,
  buttonText,
  buttonTheme,
  footerHighlightedText,
  footerNormalText,
  onButtonClick,
}) => {

  return (
    <SrBox
      styleName={classNames('SrPartnerPortalCard')}
      backgroundColor='white'
      borderRadius='24px'
      boxShadow='0px 15px 26px rgba(212, 212, 212, 0.17)'
      padding='30px 20px 20px 27px'
      minWidth='300px'
      maxWidth='575px'
      width='42%'
      marginBottom='20px'
    >
      <SrFlex align='center' direction='col'>
        <SrBox
          styleName='mainIcon'
          backgroundImage={`url(${icon})`}
        />
        <SrText
          font='greycliff'
          display='block'
          align='center'
          weight='800'
          size='36'
          paddingTop='10px'
          lineHeight='1.2'
        >
          {title}
        </SrText>
        <SrBox
          margin='auto'
          marginTop='27px'
          marginBottom='40px'
          minWidth='280px'
        >
          <SrFlex align='center'>
            <SrBox
              backgroundImage='url(/images/notes-search-icon.svg)'
              backgroundSize='contain'
              backgroundPosition='center'
              backgroundRepeat='no-repeat'
              width='57px'
              height='50px'
            />
            <SrText
              font='greycliff'
              weight='bold'
              size='16'
            >
              {firstDetail}
            </SrText>
          </SrFlex>
          <SrFlex marginTop='8px' align='center'>
            <SrBox
              backgroundImage='url(/images/sun-with-sunglasses-icon.svg)'
              backgroundSize='contain'
              backgroundPosition='center'
              backgroundRepeat='no-repeat'
              width='41px'
              height='42px'
              marginLeft='7px'
            />
            <SrText
              paddingLeft='10px'
              font='greycliff'
              weight='bold'
              size='16'
            >
              {secondDetail}
            </SrText>
          </SrFlex>
          <SrFlex marginTop='8px' align='center'>
            <SrBox
              backgroundImage='url(/images/dollar-sign-rounded.svg)'
              backgroundSize='contain'
              backgroundPosition='center'
              backgroundRepeat='no-repeat'
              width='30px'
              height='30px'
              marginLeft='12px'
            />
            <SrText
              paddingLeft='16px'
              font='greycliff'
              weight='bold'
              size='16'
            >
              {thirdDetail}
            </SrText>
          </SrFlex>
        </SrBox>
        <SrButton
          minWidth='80%'
          theme={buttonTheme}
          hasBoxShadow
          onClick={onButtonClick}
        >
          {buttonText}
        </SrButton>
        <SrText font='greycliff' paddingTop='9px' fontStyle='italic'>
          <span style={{ color:'#00A238', fontFamily:'Greycliff' }}>
            {footerHighlightedText}
          </span>{footerNormalText}
        </SrText>
      </SrFlex>
    </SrBox>
  );
};

SrPartnerPortalCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  firstDetail: PropTypes.string.isRequired,
  secondDetail: PropTypes.string.isRequired,
  thirdDetail: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonTheme: PropTypes.string.isRequired,
  footerHighlightedText: PropTypes.string.isRequired,
  footerNormalText: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func.isRequired,
};

export default SrPartnerPortalCard;
